import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import { useToast } from '../../../hooks/use-toast';
import { Loader2, Save } from 'lucide-react';
import BackButton from '../../../components/admin/BackButton';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const StatsForm = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  
  const [formData, setFormData] = useState({
    stats: [
      { number: '17+', label_pt: 'Anos no Negócio', label_en: 'Years in Business' },
      { number: '50+', label_pt: 'Projetos Entregues', label_en: 'Projects Delivered' },
      { number: '3', label_pt: 'Continentes', label_en: 'Continents' },
      { number: '95%', label_pt: 'Taxa de Retenção de Clientes', label_en: 'Client Retention Rate' }
    ]
  });

  useEffect(() => {
    loadStatsData();
  }, []);

  const loadStatsData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/homepage-ml/stats?lang=pt`);
      if (response.data && response.data.stats) {
        setFormData({ stats: response.data.stats });
      }
    } catch (error) {
      console.error('Failed to load stats:', error);
    }
    setLoading(false);
  };

  const handleStatChange = (index, field, value) => {
    setFormData(prev => {
      const newStats = [...prev.stats];
      newStats[index] = { ...newStats[index], [field]: value };
      return { ...prev, stats: newStats };
    });
  };

  const addStat = () => {
    setFormData(prev => ({
      stats: [...prev.stats, { number: '', label_pt: '', label_en: '' }]
    }));
  };

  const removeStat = (index) => {
    setFormData(prev => ({
      stats: prev.stats.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await axios.put(`${API_URL}/api/homepage-ml/stats`, formData);
      toast({ title: "Sucesso", description: "Estatísticas guardadas" });
    } catch (error) {
      toast({ variant: "destructive", title: "Erro", description: "Falha ao guardar" });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-[#00B4D8]" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-6 max-w-4xl">
        <BackButton />

        <Card className="mt-6">
          <CardHeader>
            <CardTitle>Secção Stats</CardTitle>
            <CardDescription>Configure as estatísticas da homepage</CardDescription>
          </CardHeader>

          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold">Estatísticas</h3>
                  <Button type="button" variant="outline" size="sm" onClick={addStat}>
                    + Adicionar Estatística
                  </Button>
                </div>

                {formData.stats.map((stat, idx) => (
                  <div key={idx} className="grid grid-cols-4 gap-3 mb-3 items-start">
                    <input
                      type="text"
                      value={stat.number}
                      onChange={(e) => handleStatChange(idx, 'number', e.target.value)}
                      placeholder="Número (ex: 50+)"
                      className="px-3 py-2 border rounded"
                    />
                    <input
                      type="text"
                      value={stat.label_pt}
                      onChange={(e) => handleStatChange(idx, 'label_pt', e.target.value)}
                      placeholder="Label PT"
                      className="px-3 py-2 border rounded"
                    />
                    <input
                      type="text"
                      value={stat.label_en}
                      onChange={(e) => handleStatChange(idx, 'label_en', e.target.value)}
                      placeholder="Label EN"
                      className="px-3 py-2 border rounded"
                    />
                    <Button
                      type="button"
                      variant="destructive"
                      size="sm"
                      onClick={() => removeStat(idx)}
                    >
                      Remover
                    </Button>
                  </div>
                ))}
              </div>

              <div className="flex justify-end gap-3 pt-6 border-t">
                <Button type="button" variant="outline" onClick={() => navigate('/admin/homepage')}>Cancelar</Button>
                <Button type="submit" disabled={saving} className="bg-[#00B4D8]">
                  {saving ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />A guardar...</> : <><Save className="w-4 h-4 mr-2" />Guardar</>}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default StatsForm;